// extracted by mini-css-extract-plugin
module.exports = {"footerAdSlot":"styles_footerAdSlot__b_H84","isShown":"styles_isShown__YB1y_","closeButton":"styles_closeButton__SCYvD"};